<template>
  <el-select
    :disabled="disabled"
    :style="{ width: width }"
    size="small"
    clearable
    filterable
    placeholder="请选择省份"
    v-model="resultValue"
    @change="onChange"
  >
    <el-option
      v-for="item in provinceList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { getProvince } from './api'
export default {
  name: 'SelectProvince',

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resultValue: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  data() {
    return {
      provinceList: []
    }
  },

  created() {
    this.getProvinceList()
  },

  methods: {
    async getProvinceList() {
      try {
        const res = await getProvince()
        this.provinceList = res || []
      } catch (error) {
        console.error('获取省份列表失败:', error)
        this.provinceList = []
      }
    },

    onChange(val) {
      this.$emit('change', val)
      // 获取选中省份的名称
      const selectedProvince = this.provinceList.find(item => item.id === val)
      this.$emit('province-change', {
        id: val,
        name: selectedProvince ? selectedProvince.name : ''
      })
    }
  }
}
</script>

<style></style>